import { makeStyles } from "tss-react/mui";

export type IStyleParams = {
  width: string;
  height: string;
  padding: string;
  color: string | null;
  bgColor: string | null;
  font: string | undefined;
  isDisable: boolean | undefined;
};

const useStyles = makeStyles<{ params: IStyleParams }>({
  name: "AppInput",
  uniqId: "app_input",
})((theme, { params }, classes) => {
  return {
    formControl: {
      width: params.width,

      "& .MuiButton-contained": {
        backgroundColor: `${
          params.isDisable ? "#c2c2c2c2" : "#4B2884"
        } !important`,
        borderRadius: 0,
        color: params.isDisable ? "#3333" : "#FFF",
        fontFamily: params.font ? params.font : "Noto Sans TC",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "normal",
        // letterSpacing: "3.6px",
        minWidth: params.width,
        minHeight: params.height,
        padding: params.padding,
      },

      "& .MuiButton-outlined": {
        borderRadius: 0,
        border: `1px solid ${params.color ? params.color : "#4B2884"}`,
        color: params.color ? params.color : "#4B2884",
        fontFamily: params.font ? params.font : "Noto Sans TC",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "normal",
        // letterSpacing: "3.6px",
        minWidth: params.width,
        minHeight: params.height,
        padding: params.padding,
      },
    },
  };
});

export default useStyles;
